import React, { useState, useEffect } from 'react';
import WhatsAppConnection from '../components/whatsapp/WhatsAppConnection';
import GmailSettings from '../components/settings/GmailSettings';
import ShopifySettings from '../components/settings/ShopifySettings';
import api from '../utils/api';
import { supabase } from '../utils/supabase';
import { Card, Form, Input, Button, message, Tabs, Space, Divider } from 'antd';
import { ShopOutlined, MessageOutlined, MailOutlined, SettingOutlined } from '@ant-design/icons';

const { TabPane } = Tabs;

const Settings = () => {
  const [config, setConfig] = useState({
    llm_provider: 'claude',
    api_key: '',
    prompt_template: '',
    is_active: true,
    response_parameters: {}
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');
  const [shopifyForm] = Form.useForm();

  useEffect(() => {
    // fetchConfig();
    loadSettings();
  }, []);

  // const fetchConfig = async () => {
  //   try {
  //     const { data } = await api.get('/bot/config');
  //     setConfig(data || {
  //       llm_provider: 'claude',
  //       api_key: '',
  //       prompt_template: '',
  //       response_parameters: {}
  //     });
  //   } catch (error) {
  //     console.error('Error fetching config:', error);
  //     setError('Erreur lors du chargement de la configuration');
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const loadSettings = async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return;

      const { data: settings, error } = await supabase
        .from('settings')
        .select('*')
        .eq('user_id', user.id)
        .eq('type', 'shopify')
        .single();

      
      if (settings) {
        shopifyForm.setFieldsValue({
          shop_domain: settings.shop_domain,
          webhook_secret: settings.webhook_secret,
        });
      }
    } catch (error) {
      console.error('Error loading settings:', error);
      message.error('Erreur lors du chargement des paramètres');
    } finally {
      setLoading(false);
    }
  };

  const saveShopifySettings = async (values) => {
    try {
      setLoading(true);
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return;

      const { error } = await supabase
        .from('settings')
        .upsert({
          user_id: user.id,
          type: 'shopify',
          shop_domain: values.shop_domain,
          webhook_secret: values.webhook_secret,
        }, {
          onConflict: 'user_id,type'
        });

      if (error) throw error;

      message.success('Paramètres Shopify sauvegardés');
    } catch (error) {
      console.error('Error saving settings:', error);
      message.error('Erreur lors de la sauvegarde');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError(null);
    setSuccessMessage('');

    try {
      await api.put('/bot/config', config);
      setSuccessMessage('Configuration sauvegardée avec succès');
    } catch (error) {
      console.error('Error saving config:', error);
      setError('Erreur lors de la sauvegarde de la configuration');
    } finally {
      setSaving(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setConfig(prev => ({
      ...prev,
      [name]: value
    }));
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-500"></div>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
      <Tabs defaultActiveKey="whatsapp" size="large">
        <TabPane
          tab={
            <span>
              <MessageOutlined />
              WhatsApp
            </span>
          }
          key="whatsapp"
        >
          <div className="space-y-6">
            <WhatsAppConnection />
          </div>
        </TabPane>
        
        <TabPane
          tab={
            <span>
              <ShopOutlined />
              Shopify
            </span>
          }
          key="shopify"
        >
          <div className="space-y-6">
            <ShopifySettings />
          </div>
        </TabPane>
        
        <TabPane
          tab={
            <span>
              <MailOutlined />
              Gmail
            </span>
          }
          key="gmail"
        >
          <div className="space-y-6">
            <GmailSettings />
          </div>
        </TabPane>
        
        <TabPane
          tab={
            <span>
              <SettingOutlined />
              Général
            </span>
          }
          key="general"
        >
          <div className="space-y-6">
            {/* General settings content */}
            <Card title="Paramètres Généraux">
              <p>Paramètres généraux de l'application</p>
            </Card>
          </div>
        </TabPane>
      </Tabs>
    </div>
  );
};

export default Settings;
